<template>
  <div>
    <h1>입주 안내</h1>
  </div>
</template>
